var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "6194 -3160 16 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#7D9CC4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5985 -3190)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12,
    height: 2,
    transform: "translate(213 30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 2,
    transform: "translate(209 34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13,
    height: 2,
    transform: "translate(209 38)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.854913d5097fa4f4a25b7efd9a156f39.svg";
export { ForwardRef as ReactComponent };